module.exports = __webpack_public_path__ + "img/mir.4294761.svg";